
import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import SoundObject from "../../../lib/services/sound/sound_object";
import Stage from "../../../lib/services/stage/stage";

export default class SpatialMusic extends SceneObject
{

    tracks: SoundObject[] = [];
    bpm:number = 123; // for when I add beat timing

    constructor(key: string) 
    {
        super(key);
       
    }
    
      async build(
        device: GPUDevice,
        format: GPUTextureFormat,
        shader_service: ShaderService,
        resource_service: ResourceService
      ): Promise<void> 
      {
         
         this.tracks.push(new SoundObject("arp","streetgirl_arp.wav", -0.071065902709961,0,1.076142311096191));
         this.tracks.push(new SoundObject("bass","streetgirl_bass.wav",0.832487106323242,0,-1.197969436645508));
         this.tracks.push(new SoundObject("chord","streetgirl_chord.wav",-1.380710601806641,0, -0.416243553161621));
         this.tracks.push(new SoundObject("hat","streetgirl_hat.wav",-1.218274116516113,0,0.507614135742188));
         this.tracks.push(new SoundObject("hat2","streetgirl_hat2.wav",1.238578796386719,0,-0.426395893096924));
         this.tracks.push(new SoundObject("kick","streetgirl_kick.wav",1.218274116516113,0, 0.578680038452148));
         this.tracks.push(new SoundObject("perc","streetgirl_perc.wav",0.010152339935303,0,-1.532994985580444));
         this.tracks.push(new SoundObject("ride","streetgirl_ride.wav",-0.954314708709717,0,-1.13705587387085));

         for (const track of this.tracks) 
         {
            track.build(device,format,shader_service,resource_service);
         }

         Stage.instance().sound_service.set_listener(this);

      }

      play():void
      {
         for (const track of this.tracks) 
         {
                track.play(true); 
         }
      }

      stop():void
      {

         for (const track of this.tracks) 
         {
            track.stop();
         }
      }

    override tick(delta_time: number): void 
    {
        for (const track of this.tracks) 
         {
            track.tick(delta_time);
         }
    }

    override ui_message(cmd: string, msg: string): void 
    {
        if(cmd = "music")
        {
                if(msg == "play")
                {
                    this.play();
                }
                else if(msg == "stop")
                {
                    this.stop();
                }
        }

         super.ui_message(cmd, msg);
    }

}